import React from 'react';
import { Button, Dialog, DialogActions, DialogContent } from "@material-ui/core";
import UserCard from '../userCard';

const UserModal = ({ user, onClose }) => {
    return (
        <Dialog
            open={true}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogContent>
                <UserCard user={user} />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default UserModal;